import { inject, Injectable } from '@angular/core';
import { CurrenciesService, CurrencyModel } from '@railmybox/api-pricing';
import { Observable } from 'rxjs';

@Injectable()
export class ValueCurrencyService {
  private currencyService = inject(CurrenciesService);

  getCurrencyList(): Observable<CurrencyModel[]> {
    return this.currencyService.listCurrencies();
  }
}
